// @ts-nocheck
import Button from 'atoms/button/button';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as generateOrderSelectors from './selectors';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import * as constants from './constants';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { Typography } from 'antd';
import { useColumnAliasName } from 'hooks/useColumnAliasName';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';

type TProps = {
	hideModal: React.MouseEventHandler;
	handleNextClick: React.MouseEventHandler;
	goBack: React.MouseEventHandler;
};

const { Title } = Typography;

const SelectStores = (props: TProps) => {
	const { handleNextClick, goBack } = props;

	const dispatch = useDispatch();

	const data = useSelector((state) => generateOrderSelectors.getData(state));

	const getColumnAliasName = useColumnAliasName(constants.UPLOAD_MODEL_ID);

	const selectedStores = useSelector((state) =>
		dynamicGridSelectors.getTableSelection(state, constants.MODAL_TABLE_IDS.STORES)
	);

	const isLoadingGrid = useSelector((state) =>
		dynamicGridSelectors.isLoading(state, constants.MODAL_TABLE_IDS.STORES)
	);
	const hasGridData = useSelector(
		(state) => dynamicGridSelectors.getGridData(state, constants.MODAL_TABLE_IDS.STORES)?.length
	);

	React.useEffect(() => {
		dispatch(fetchBookmarksList({ tableId: constants.MODAL_TABLE_IDS.STORES }));
	}, [dispatch]);

	const [ref, handleUpdateRef] = useState(null);

	const validateFormData = React.useCallback(() => {
		let hasError = true;

		if (
			selectedStores &&
			((selectedStores.isSelectAll && hasGridData) ||
				(selectedStores?.selectedRowKeys && selectedStores?.selectedRowKeys.length))
		) {
			hasError = false;
		}

		return hasError;
	}, [selectedStores]);

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		selectionCallBack: () => {},
	};

	const customerOptions = useSelector((state) => generateOrderSelectors.getCustomerOptions(state));

	const templateConfig = {
		gridConfig,
		isFilterEnabled: true,
		tableId: constants.MODAL_TABLE_IDS.STORES,

		dataProviderOptions: {
			version: 2,
			type: 'POST',
			...REQUESTS.POST.GET_GRID_DETAILS_V2,
			pathParams: { tableId: constants.MODAL_TABLE_IDS.STORES },
			queryParams: {},
			multiSelectFieldGroups: {
				CustomerID: data?.customerID?.includes('-1')
					? customerOptions.map(({ value }) => value).join(',')
					: data?.customerID,
				StoreScheduleID: data?.useStoreSchedule ? data.storeScheduleID : undefined,
				StartShipDate: data?.shipStartDate,
				EndShipDate: data?.shipToDate || new Date(),
				WareHouseID: data?.isPrimaryWarehouse ? data.warehouseID : null,
				UsePrimaryWarehouse: Boolean(data.isPrimaryWarehouse),
				UsePlanogram: data.usePlanogram,
			},
			body: {
				fieldGroups: {
					CustomerID: data?.customerID?.includes('-1')
						? customerOptions.map(({ value }) => value).join(',')
						: data?.customerID,
					StoreScheduleID: data?.useStoreSchedule ? data.storeScheduleID : undefined,
					StartShipDate: data?.shipStartDate,
					EndShipDate: data?.shipToDate || new Date(),
					WareHouseID: data?.isPrimaryWarehouse ? data.warehouseID : null,
					UsePrimaryWarehouse: Boolean(data.isPrimaryWarehouse),
					UsePlanogram: data.usePlanogram,
				},
			},
		},
		selectRowKey: 'StoreID',
	};
	return (
		<Sheet isPage className="order-tbl p-0">
			<SheetBody isTransparent className="p-0">
				<Stack isVertical className="generte-order-wrapper">
					<Stack className="generte-order-head p-0">
						<Title level={4}>{getColumnAliasName('Select Store')}</Title>
					</Stack>
					<StackItem onDomRef={handleUpdateRef} isStretch isGrow>
						<ThetaGridPaginated offset={60} parent={ref} isStorageEnabled={false} config={templateConfig} />
					</StackItem>
					<StackItem>
						<Stack className="card-footer orderinfo-footer">
							<StackItem isGrow>
								<Stack align="left" gutter="small">
									<StackItem>
										<Button isText name="Reset Order Info" handleClick={goBack} />
									</StackItem>
								</Stack>
							</StackItem>
							<StackItem>
								<Stack align="right" gutter="small">
									<StackItem isStretch align="right">
										<Button
											isPrimary
											disabled={(isLoadingGrid && !hasGridData) || validateFormData()}
											name={getColumnAliasName('Select SKUs')}
											handleClick={handleNextClick}
										/>
									</StackItem>
								</Stack>
							</StackItem>
						</Stack>
					</StackItem>
				</Stack>
			</SheetBody>
		</Sheet>
	);
};

export default SelectStores;
